import { Mail, Globe } from 'lucide-react'
import { AmbaMark, AMBA_EMAIL } from './brand'

/** Footer for the ScamDefense AMBA pitch (navy + gold). */
export default function AmbaFooter() {
  return (
    <footer className="bg-[#253a3f] text-white">
      <div className="h-1 w-full bg-[#c8a04b]" />
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <AmbaMark className="text-xl" />
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/80">
            <a href={`mailto:${AMBA_EMAIL}`} className="inline-flex items-center gap-2 hover:text-white">
              <Mail className="h-4 w-4 text-[#d9bd76]" />
              {AMBA_EMAIL}
            </a>
            <a href="https://scamdefense.org" className="inline-flex items-center gap-2 hover:text-white">
              <Globe className="h-4 w-4 text-[#d9bd76]" />
              scamdefense.org
            </a>
          </div>
        </div>
        <p className="mt-8 border-t border-white/10 pt-6 text-xs text-white/50">
          &copy; {new Date().getFullYear()} ScamDefense. Educational content. Not legal or financial advice.
        </p>
      </div>
    </footer>
  )
}
